import React from 'react';
import $ from 'jquery';
import Config from '../utils/config';
import { getCookie, deleteCookie } from '../utils/cookie';
import { GetQueryString , getFullUrlPath} from '../utils/common';


export default class PopupCongra extends React.Component {
	state = {
		lbl_Congratulationstitle: '',
		lbl_Congratulations1: '',
		lbl_Congratulations2: '',
		lbl_Congratulations3: '',
		lbl_Congratulations4: '',
		lbl_Congratulations5: '',
		lbl_Congratulations6: '',
		lbl_Congratulations7: '',
		lbl_Congratulations8: '',
		lbl_Congratulations9: '',
		lbl_mailwelcome_mail: '',
		lbl_CongratulationsOther: '',
		SiteName: Config.appConfig.SiteTitle
	};

	popupDiv(type) {
		this.props.popupDiv(type);
	}

	componentDidMount() {
		// var self = this;
		$.ajax({
			url: getFullUrlPath('getOption.ashx?setPara=congra'),
			dataType: 'json',
			async: false,
			success: data => {
				this.setState({
					lbl_Congratulationstitle: data.lbl_Congratulationstitle,
					lbl_Congratulations1: data.lbl_Congratulations1,
					lbl_Congratulations2: data.lbl_Congratulations2,
					lbl_Congratulations3: data.lbl_Congratulations3,
					lbl_Congratulations4: data.lbl_Congratulations4,
					lbl_Congratulations5: data.lbl_Congratulations5,
					lbl_Congratulations6: data.lbl_Congratulations6,
					lbl_Congratulations7: data.lbl_Congratulations7,
					lbl_Congratulations8: data.lbl_Congratulations8,
					lbl_Congratulations9: data.lbl_Congratulations9,
					lbl_mailwelcome_mail: data.lbl_mailwelcome_mail,
					lbl_CongratulationsOther: data.lbl_CongratulationsOther
				});
			}
		});
		window.history.pushState('','','?');
	}


	openLiveWindow = () => {
		const theURL = `//${this.state.lbl_Congratulations4}`;
		const theTarget = "_blank";
		const PageSetting = 'width=430,height=454,menubar=no,status=no';

		window.open(theURL, theTarget, PageSetting);
	}

	render() {
		const seqNO = getCookie("popupCongSeq");
		let sendMGID = false;
		const test = false;//GetQueryString("test");
		const queryMgid_url = decodeURIComponent(GetQueryString("mgid_url"));
		if(seqNO || test) {
			const querySeqNO = GetQueryString("seq");
			if((seqNO === querySeqNO || test) && queryMgid_url) {
				sendMGID = true;
			}
			deleteCookie("popupCongSeq");
		}
		return (
			<div className="blocker">
				{sendMGID && 
					<iframe 
						id="imgid" 
						src={queryMgid_url} 
						height="0%" 
						width="0%" >
					</iframe>}
				<div className="modal popup-signup">
					<a
						href="javascript:void(0);"
						onClick={this.popupDiv.bind(this, -1)}
						title="Close"
						className="close"
					>
						<i className="icon-close" />
					</a>
					{
						Config.appConfig.SiteName != 'BE7' && (
							<React.Fragment>
								<h2>{this.state.lbl_Congratulationstitle}</h2>
								<div>
									<div className="txt">{this.state.lbl_Congratulations1}</div>
									<div className="txt">{this.state.lbl_Congratulations2}</div>
									<br />
									<div className="txt">{this.state.lbl_Congratulations3}</div>
									<div className="txt" dangerouslySetInnerHTML={{ __html: this.state.lbl_CongratulationsOther }}></div>
									<div className="txt">
										{this.state.lbl_Congratulations4}
										<ul>
											<li>{this.state.lbl_Congratulations5}</li>
											<li>{this.state.lbl_Congratulations6}</li>
											<li>
												{this.state.lbl_Congratulations7}{' '}
												<a
													href={
														'mailto:' +
														this.state.lbl_mailwelcome_mail +
														'?subject=Enquiries sent from ' +
														this.state.SiteName +
														'website'
													}
												>
													<u>{this.state.lbl_mailwelcome_mail}</u>
												</a>{' '}
												{this.state.lbl_Congratulations8}
											</li>
											<li dangerouslySetInnerHTML={{ __html: this.state.lbl_Congratulations9 }} ></li>
										</ul>
									</div>
								</div>
							</React.Fragment>
						)
					}
					{
						Config.appConfig.SiteName == 'BE7' && (
							<React.Fragment>
								<h2>{this.state.lbl_Congratulationstitle}</h2>
								<div>
									<div className="txt">{this.state.lbl_Congratulations1}</div>
									<div className="txt">{this.state.lbl_Congratulations2}</div>
									<div className="txt">
										{this.state.lbl_Congratulations3}
										<a 
											href="javascript:void(0);"
											onClick={this.openLiveWindow}
										>
											{this.state.lbl_Congratulations4}
										</a>
										{this.state.lbl_Congratulations5}
									</div>
								</div>
							</React.Fragment>
						)
					}
					
				</div>
			</div>
		);
	}
}
